import React, { CSSProperties } from 'react';
import styled, { css, ThemeProps } from 'styled-components';
import { colors } from 'styleguide/colors';
import { Icon, MicroIcon } from 'styleguide/Icons';
import { Input } from 'styleguide/Inputs';
import { CornerRadius, Spacing } from 'styleguide/spacing';
import { Theme } from 'styleguide/types';
import { FlexRow } from 'styleguide/Row';

const Container = styled(FlexRow)<{ type: 'primary' | 'secondary' }>`
  border-radius: ${CornerRadius.md}px;

  ${(props: { type: 'primary' | 'secondary' } & ThemeProps<Theme>) =>
    props.type === 'primary'
      ? css`
          background-color: ${
            props.theme.name === 'light' ? colors.greyUltraLight : colors.greyDark
          };
        `
      : css`
          background-color: ${props.theme.name === 'light' ? colors.white : colors.greyUltraDark};
          border: solid;
          border-width: 1px;
          border-color: ${props.theme.name === 'light' ? colors.greyLight : colors.greyDark};
        `};
`;

const ClearInputContainer = styled(FlexRow)`
  cursor: pointer;
`;

const InputContainer = styled(FlexRow)`
  height: 38px;
  flex: 1;
  @-moz-document url-prefix() {
    /* Without this the clear text button is misplaced on firefox */
    margin-inline-end: -20px;
  }
`;

interface SearchInputProps {
  value: string;
  type: 'primary' | 'secondary';
  placeholder: string;
  onChange: (value: string) => void;
  spellCheck?: boolean;
  style?: CSSProperties;
}

export const SearchInput = ({
  value,
  type,
  placeholder,
  onChange,
  spellCheck,
  style,
}: SearchInputProps) => {
  return (
    <Container type={type} style={style}>
      <InputContainer>
        <Icon
          type={'search'}
          tint={colors.grey}
          style={{ flexShrink: 0, marginInlineStart: Spacing.sm, marginInlineEnd: Spacing.sm }}
        />
        <Input
          style={{ backgroundColor: colors.transparent, width: '90%' }}
          placeholder={placeholder}
          value={value}
          spellCheck={spellCheck}
          onChange={e => onChange(e.currentTarget.value)}
        />
      </InputContainer>

      {!!value.length && (
        <ClearInputContainer onClick={() => onChange('')}>
          <MicroIcon type={'cross'} tint={colors.grey} style={{ marginInlineEnd: Spacing.sm }} />
        </ClearInputContainer>
      )}
    </Container>
  );
};
